import React from "react";
import { Spinner } from "@chakra-ui/react";

function Loading(){
  return (
    <span>Loading ...</span>
  )
}

export default Loading;